import tw, { styled } from 'twin.macro';

export const StyledHero = styled('div')`
  ${tw`mb-12 lg:block md:hidden`}
`;

export const MainContainer = styled.div`
  ${tw`grid grid-flow-col grid-cols-3 auto-rows-auto gap-4 leading-normal`}
  max-width: 1000px;
`;

export const CenterContainer = styled.div`
  ${tw`mx-auto  leading-normal`}
  max-width: 800px;
`;

export const LeftContainer = styled.div`
  ${tw`flex flex-col gap-y-1 bg-gray-400  p-2`}
`;

export const RightContainer = styled.div`
  ${tw` col-span-3 p-2 mx-auto max-w-2xl`}
`;

export const B = styled.div`
  ${tw` font-semibold inline-block`}
`;

export const ListDisc = styled.ul`
  ${tw`
  leading-relaxed
  list-inside
  text-gray-800
  `}
  list-style-type: circle;
`;

export const Question = styled.div`
  ${tw`font-semibold mb-0.5 mt-2`}
`;

export const Response = styled.div`
  ${tw`italic`}
  &:before {
    content: 'Re:' ${tw`font-semibold`};
    margin-right: 4px;
  }
`;
